const Logo = () => {
  return (
    <h3 className='logo' style={{ color: '#00b0ff', fontWeight: 'bold' }}>
      Job Tracking
    </h3>
  );
};
export default Logo;
